import { render, staticRenderFns } from "./BasicList.vue?vue&type=template&id=8b36916c&scoped=true&"
import script from "./BasicList.vue?vue&type=script&lang=js&"
export * from "./BasicList.vue?vue&type=script&lang=js&"
import style0 from "./BasicList.vue?vue&type=style&index=0&id=8b36916c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b36916c",
  null
  
)

export default component.exports